import { Icon } from '@chakra-ui/react';

export default function LinkIcon(props) {
  return (
    <Icon
      width='20px'
      height='21px'
      viewBox='0 0 20 21'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M9.88151 14.1017C8.71485 13.9012 7.98568 13.491 7.41146 12.9168C5.19662 10.7111 5.21485 7.61214 7.40235 5.42464L10.5104 2.30746C12.6979 0.119956 15.7969 0.101727 18.0117 2.31657C20.2175 4.53141 20.1992 7.62126 18.0208 9.80876L15.3411 12.4793C15.4323 11.8869 15.3776 11.2124 15.1224 10.6291L16.9089 8.84261C18.4857 7.26579 18.5039 5.01449 16.9089 3.41944C15.3138 1.82438 13.0716 1.8335 11.4766 3.41944L8.50521 6.39079C6.92839 7.96761 6.91927 10.228 8.51433 11.8231C9.10677 12.4155 9.89063 12.7801 11.0938 12.8713L9.88151 14.1017ZM10.1094 6.59131C11.276 6.79183 12.0052 7.20199 12.5794 7.77621C14.7943 9.98193 14.776 13.0809 12.5885 15.2684L9.47136 18.3947C7.29297 20.5731 4.19401 20.5913 1.97917 18.3765C-0.226561 16.1707 -0.208332 13.0718 1.97005 10.8843L4.64974 8.21371C4.54948 8.80615 4.61328 9.48975 4.86849 10.064L3.08203 11.8504C1.4961 13.4364 1.48698 15.6785 3.08203 17.2827C4.67709 18.8687 6.91927 18.8595 8.50521 17.2736L11.4857 14.3022C13.0625 12.7254 13.0716 10.465 11.4766 8.86996C10.8841 8.27751 10.1003 7.92204 8.89714 7.82178L10.1094 6.59131Z' />
    </Icon>
  );
}
